<template>
  <base-readonly-table
    :title="testsTitle"
    route-name="vesselTrialTest"
    get-url="/bytrial"
    :headers="headers"
    :url="url"
    :item="vesselTrialTest"
    :item-id="vesselTrialTest.vesselTrialTestId"
    :get-id="id"
    @set-item="setItem"
  ></base-readonly-table>
</template>
<script>
import ObjectType from '@/services/Objects.js'
import BaseReadonlyTable from '@/components/tables/BaseReadonlyTable.vue'

export default {
  name: 'VesselTrialTestTable',
  components: {
    BaseReadonlyTable
  },
  props: {
    id: String,
    trialName: String
  },
  data() {
    return {
      headers: [
        { text: 'Number', value: 'order', width: '100px', align: 'end' },
        { text: 'Name', value: 'name' },
        { text: 'Actions', value: 'action', width: '100px', align: 'center' }
      ],
      vesselTrialTest: {},
      url: ObjectType.VesselTrialTest
    }
  },
  computed: {
    testsTitle() {
      return this.trialName + ': Tests'
    }
  },
  methods: {
    setItem(item) {
      this.vesselTrialTest = Object.assign({}, item)
    }
  }
}
</script>

<style scoped></style>
